import { streamQuery, } from '@Utils';
import { ElevenlabsVoiceEnum, IPreviewSound, ISharedSound, } from 'atlas-shared/dist';

export * from './abstract/sound.api.abstract';

export const streamSoundTextDemo = (id: IPreviewSound['id'], text: ISharedSound['text'], voice?: ElevenlabsVoiceEnum, onError?: (error) => void) => {
  return streamQuery(`sound/${id}/demo`, { text, voice, }, onError);
};
